import axios from "axios";

interface DownloadQRCodeConfig {
  fileName?: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

/**
 * Downloads a QR code image from a given URL
 * @param qrCodeUrl - The URL of the QR code image
 * @param config - Configuration options for the download
 * @param config.fileName - The name of the file to save the QR code as
 * @param config.onSuccess - Callback function to execute on successful download
 * @param config.onError - Callback function to execute on error
 */
export const downloadQRCode = async (
  qrCodeUrl: string,
  config: DownloadQRCodeConfig = {
    fileName: "qr_code.png",
  },
) => {
  if (!qrCodeUrl) return;

  try {
    const response = await axios.get(qrCodeUrl, {
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const imageURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = config.fileName || "qr_code.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(imageURL); // Clean up the blob URL
    config.onSuccess?.();
  } catch (e) {
    console.error({ e });
    config.onError?.(e as Error);
  }
};
